/*
 * DGA - Productvergelijker
 *
 * Drie verantwoordelijkheden:
 *  1. State: welke producten staan in de vergelijking (localStorage, cross-tab).
 *  2. Balk: de vaste onderbalk met chips en de "Vergelijk"-knop.
 *  3. Pagina: de vergelijktabel hydrateren uit /products/<handle>?view=vergelijk-ws2-0.
 *
 * Bewust geen custom element en geen pubsub: de checkboxes leven in grid-HTML
 * die door facets.js en Ajaxinate volledig vervangen wordt. Event-delegation op
 * document plus een MutationObserver overleeft dat, een component-instantie niet.
 */
(function () {
  'use strict';

  var KEY = 'dga:compare:v1:list';
  var CACHE_PREFIX = 'dga:cmp:v6:'; /* v6: productlift, aansluiting, ai_vision en antivries erbij (29 sep 2026) */
  var CACHE_TTL = 30 * 60 * 1000;
  var MAX = 4;
  var EVENT = 'dga:compare:change';

  /* ---------------------------------------------------------------- storage */
  /* Safari private mode en sommige cookiebanners gooien op storage-toegang.
     Alles valt dan terug op geheugen: de feature wordt sessie-only, nooit stuk. */
  var memory = {};

  function readStore(store, key) {
    try {
      return window[store].getItem(key);
    } catch (e) {
      return Object.prototype.hasOwnProperty.call(memory, key) ? memory[key] : null;
    }
  }

  function writeStore(store, key, value) {
    memory[key] = value;
    try {
      window[store].setItem(key, value);
    } catch (e) {
      /* geheugen is al bijgewerkt */
    }
  }

  /* ------------------------------------------------------------------ state */
  var state = { scope: null, items: [] };

  function load() {
    var raw = readStore('localStorage', KEY);
    if (!raw) {
      state = { scope: null, items: [] };
      return;
    }
    try {
      var parsed = JSON.parse(raw);
      state = {
        scope: parsed.scope || null,
        items: Array.isArray(parsed.items) ? parsed.items.slice(0, MAX) : []
      };
    } catch (e) {
      state = { scope: null, items: [] };
    }
  }

  function save() {
    writeStore('localStorage', KEY, JSON.stringify({ v: 1, scope: state.scope, items: state.items }));
  }

  function indexOf(id) {
    for (var i = 0; i < state.items.length; i++) {
      if (String(state.items[i].id) === String(id)) return i;
    }
    return -1;
  }

  var API = {
    MAX: MAX,

    get: function () {
      return { scope: state.scope, items: state.items.slice() };
    },

    has: function (id) {
      return indexOf(id) !== -1;
    },

    /* Geeft {ok:false, reason:'max'|'scope'} terug zodat de aanroeper kan
       beslissen wat de gebruiker te zien krijgt. Nooit stilzwijgend wissen. */
    add: function (item) {
      if (indexOf(item.id) !== -1) return { ok: true };
      if (state.scope && item.scope && state.scope !== item.scope) {
        return { ok: false, reason: 'scope', scope: state.scope };
      }
      if (state.items.length >= MAX) return { ok: false, reason: 'max' };
      state.scope = state.scope || item.scope || 'automaten';
      state.items.push(item);
      save();
      emit();
      return { ok: true };
    },

    remove: function (id) {
      var i = indexOf(id);
      if (i === -1) return;
      state.items.splice(i, 1);
      if (!state.items.length) state.scope = null;
      save();
      emit();
    },

    toggle: function (item) {
      if (indexOf(item.id) !== -1) {
        API.remove(item.id);
        return { ok: true, removed: true };
      }
      return API.add(item);
    },

    clear: function () {
      state = { scope: null, items: [] };
      save();
      emit();
    },

    /* Vervangt de lijst in één keer. Gebruikt door "Wissen en toevoegen". */
    replaceWith: function (item) {
      state = { scope: item.scope || 'automaten', items: [item] };
      save();
      emit();
    },

    handles: function () {
      return state.items.map(function (i) { return i.handle; });
    },

    url: function () {
      var base = (document.getElementById('dga-compare-bar') || {}).dataset;
      var path = (base && base.compareUrl) || '/pages/vergelijken';
      var hs = API.handles();
      return hs.length ? path + '?p=' + hs.join(',') : path;
    }
  };

  function emit() {
    document.dispatchEvent(new CustomEvent(EVENT, { detail: API.get() }));
  }

  window.DGACompare = API;

  /* -------------------------------------------------- checkboxes op de kaart */
  function itemFromInput(input) {
    var d = input.dataset;
    return {
      id: d.id,
      handle: d.handle,
      scope: d.scope || 'automaten',
      title: d.title || '',
      url: d.url || '',
      image: d.image || '',
      price: parseInt(d.price, 10) || 0
    };
  }

  function syncCheckboxes() {
    var inputs = document.querySelectorAll('input[data-dga-cmp-toggle]');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].checked = API.has(inputs[i].dataset.id);
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('input[data-dga-cmp-toggle]') : null;
    if (!input) return;

    var item = itemFromInput(input);
    var result = input.checked ? API.add(item) : (API.remove(item.id), { ok: true });

    if (result.ok) return;

    /* Geweigerd: de checkbox moet expliciet terug. preventDefault werkt niet
       op een change-event van een checkbox, de browser heeft hem al omgezet. */
    input.checked = false;
    if (result.reason === 'max') {
      notify(str('maxMelding').replace('{n}', MAX));
    } else if (result.reason === 'scope') {
      askScopeSwitch(item);
    }
  });

  /* ------------------------------------------------------------------- balk */
  var bar = null;
  var page = null;

  /* De balk draagt de teksten op collectie-, product- en zoekpagina's; de
     vergelijkpagina heeft geen balk, daar levert de sectie ze. */
  function str(name) {
    if (bar && bar.dataset[name]) return bar.dataset[name];
    if (page && page.dataset[name]) return page.dataset[name];
    return '';
  }

  function notify(message) {
    if (!bar) return;
    var slot = bar.querySelector('[data-dga-cmp-melding]');
    if (!slot) return;
    slot.textContent = message;
    slot.hidden = false;
    window.clearTimeout(notify._t);
    notify._t = window.setTimeout(function () { slot.hidden = true; }, 5000);
  }

  function askScopeSwitch(item) {
    if (!bar) return;
    var slot = bar.querySelector('[data-dga-cmp-melding]');
    if (!slot) return;
    slot.textContent = '';
    slot.hidden = false;

    var text = document.createElement('span');
    text.textContent = str('scopeMelding') + ' ';
    slot.appendChild(text);

    var yes = document.createElement('button');
    yes.type = 'button';
    yes.className = 'dga-cmp-bar__link';
    yes.textContent = str('scopeWissen');
    yes.addEventListener('click', function () {
      API.replaceWith(item);
      slot.hidden = true;
    });
    slot.appendChild(yes);

    var no = document.createElement('button');
    no.type = 'button';
    no.className = 'dga-cmp-bar__link';
    no.textContent = str('scopeAnnuleren');
    no.addEventListener('click', function () { slot.hidden = true; });
    slot.appendChild(no);
  }

  /* Hoogte van de zichtbare balk als CSS-variabele op <html>, zodat andere
     zwevende elementen (o.a. de keuzemodel-knop) erboven kunnen gaan staan.
     De knop wordt alleen opgetild als hij de balk horizontaal ook echt raakt:
     op brede schermen staat hij rechts naast de balk en hoeft er niets. */
  function syncBarHeight() {
    if (!bar) return;
    if (bar.hidden) {
      document.body.classList.remove('dga-cmp-bar-overlap');
      return;
    }
    document.documentElement.style.setProperty('--dga-cmp-bar-h', bar.offsetHeight + 'px');
    var fab = document.querySelector('.dga-kz__fab');
    var overlap = false;
    if (fab) {
      var inner = bar.querySelector('.dga-cmp-bar__inner') || bar;
      var f = fab.getBoundingClientRect();
      var b = inner.getBoundingClientRect();
      overlap = f.width > 0 && f.right > b.left && f.left < b.right;
    }
    document.body.classList.toggle('dga-cmp-bar-overlap', overlap);
  }

  function renderBar() {
    if (!bar) return;
    var items = state.items;
    var list = bar.querySelector('[data-dga-cmp-chips]');
    var count = bar.querySelector('[data-dga-cmp-teller]');
    var go = bar.querySelector('[data-dga-cmp-go]');

    bar.hidden = items.length === 0;
    document.body.classList.toggle('dga-cmp-bar-open', items.length > 0);

    if (count) count.textContent = String(items.length);
    if (go) {
      var tooFew = items.length < 2;
      go.href = API.url();
      go.setAttribute('aria-disabled', tooFew ? 'true' : 'false');
      go.classList.toggle('is-disabled', tooFew);
      if (tooFew) {
        go.title = str('minHint');
      } else {
        go.removeAttribute('title');
      }
      /* Op mobiel is de knop de hele balk, dus het aantal hoort erin. */
      var teller = go.querySelector('[data-dga-cmp-gocount]');
      if (teller) teller.textContent = '(' + items.length + ')';
    }
    if (!list) { syncBarHeight(); return; }

    list.textContent = '';
    items.forEach(function (item) {
      var chip = document.createElement('li');
      chip.className = 'dga-cmp-bar__chip';

      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.width = 48;
        img.height = 48;
        img.loading = 'lazy';
        chip.appendChild(img);
      }

      var title = document.createElement('span');
      title.className = 'dga-cmp-bar__chiptitle';
      title.textContent = item.title;
      chip.appendChild(title);

      var del = document.createElement('button');
      del.type = 'button';
      del.className = 'dga-cmp-bar__remove';
      del.setAttribute('aria-label', str('verwijderLabel').replace('{titel}', item.title));
      del.textContent = '×';
      del.addEventListener('click', function () {
        API.remove(item.id);
        var next = list.querySelector('.dga-cmp-bar__remove');
        if (next) next.focus();
      });
      chip.appendChild(del);

      list.appendChild(chip);
    });
    syncBarHeight();
  }

  function initBar() {
    bar = document.getElementById('dga-compare-bar');
    if (!bar) return;
    window.addEventListener('resize', syncBarHeight);
    var clear = bar.querySelector('[data-dga-cmp-clear]');
    if (clear) clear.addEventListener('click', function () { API.clear(); });
    renderBar();
  }

  /* -------------------------------------------------------- blob-parser
     custom.specificaties is rich text met regels "Label: waarde;". Zelfde
     splitsing als dga-pdp.js transform(); bewust gekopieerd in plaats van
     gedeeld, om geen regressie op de PDP-specificatietab te riskeren. */
  function normLabel(s) {
    return String(s || '')
      .replace(/ /g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/[\s:;.]+$/, '')
      .trim()
      .toLowerCase();
  }

  /* De eerste dubbele punt is niet altijd de scheiding. Twee vormen komen echt
     voor in custom.specificaties:
       "Gewicht (Netto: standaard zonder opties): 360Kg"  -> punt binnen haakjes
       "Afmetingen: H X B X D: 1830 x 885 x 780 (mm)"     -> punt in de waarde
     Splitsen op de eerste dubbele punt buiten haakjes dekt beide. */
  function splitAt(text) {
    var depth = 0;
    for (var i = 0; i < text.length; i++) {
      var c = text.charAt(i);
      if (c === '(' || c === '[') depth++;
      else if (c === ')' || c === ']') depth = Math.max(0, depth - 1);
      else if (c === ':' && depth === 0) return i;
    }
    return -1;
  }

  /* "Gewicht (Netto)" wordt ook als "gewicht" geindexeerd, zodat één alias
     alle varianten van hetzelfde label vangt. */
  function baseLabel(label) {
    return normLabel(label.replace(/\([^)]*\)/g, ' '));
  }

  /* Hoogte, breedte en diepte staan lang niet overal als los metaveld, maar
     bijna altijd wel als "1830 x 885 x 780 (mm)" in de specificatietekst.
     Alleen invullen wat nog leeg is; een bestaand metaveld blijft leidend. */
  function vulAfmetingenAan(product) {
    var v = product.velden || (product.velden = {});
    if (v.hoogte && v.breedte && v.diepte) return;

    var bron = product._blob['afmetingen'] || product._blob['afmetingen h x b x d'] || '';
    var m = bron.match(/(\d{2,4})\s*[x×]\s*(\d{2,4})\s*[x×]\s*(\d{2,4})/i);
    if (!m) return;

    var eenheid = /\bcm\b/i.test(bron) ? 1 : 0.1; /* standaard staat het in mm */
    var namen = ['hoogte', 'breedte', 'diepte'];
    for (var i = 0; i < 3; i++) {
      if (v[namen[i]]) continue;
      var cm = parseInt(m[i + 1], 10) * eenheid;
      /* Op één decimaal, en zonder overbodige ",0". */
      v[namen[i]] = String(Math.round(cm * 10) / 10).replace('.', ',');
    }
  }

  function parseBlob(html) {
    var map = {};
    if (!html) return map;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var items = doc.querySelectorAll('li');
    for (var i = 0; i < items.length; i++) {
      var text = (items[i].textContent || '').replace(/ /g, ' ').trim();
      var at = splitAt(text);
      if (at === -1) continue;
      var label = normLabel(text.slice(0, at));
      var value = text.slice(at + 1).replace(/[\s;.]+$/, '').trim();
      /* Een korte, cijferloze prefix als "H X B X D:" herhaalt alleen het
         label en hoort niet in de cel. */
      value = value.replace(/^([^:0-9]{1,14}):\s*/, '').trim();
      if (!label || !value) continue;
      map[label] = value;
      var base = baseLabel(label);
      if (base && !map[base]) map[base] = value;
    }
    return map;
  }

  /* --------------------------------------------------------------- fragment */
  /* Het thema hoort in de sleutel: staging en live kunnen een ander fragment
     opleveren, en dan wil je niet dat de een de cache van de ander leest. */
  function cacheKey(handle) {
    var theme = (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || 'x';
    return CACHE_PREFIX + theme + ':' + (document.documentElement.lang || 'nl') + ':' + handle;
  }

  function readCache(handle) {
    var raw = readStore('sessionStorage', cacheKey(handle));
    if (!raw) return null;
    try {
      var entry = JSON.parse(raw);
      if (Date.now() - entry.t > CACHE_TTL) return null;
      /* Alleen een fragment dat er als fragment uitziet. Een eerdere versie
         cachete per ongeluk Shopify's eigen product-JSON; zonder deze controle
         blijft die tot het einde van de sessie de kolom slopen. */
      if (!entry.d || entry.d.ok !== true) return null;
      return entry.d;
    } catch (e) {
      return null;
    }
  }

  function fetchProduct(handle) {
    var cached = readCache(handle);
    if (cached) return Promise.resolve(cached);

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    /* Géén Accept: application/json meesturen. Shopify geeft dan de standaard
       product-JSON terug in plaats van dit template, en de kolom blijft leeg. */
    var url = root + 'products/' + encodeURIComponent(handle) + '?view=vergelijk-ws2-0';

    /* Een fetch draagt de themacontext van de preview niet mee: Shopify
       handelt hem af met het gepubliceerde thema, dat dit template niet heeft
       en dus HTML teruggeeft. Het thema-id expliciet meesturen houdt de
       vergelijker werkend op staging en in de theme-editor. */
    var theme = window.Shopify && window.Shopify.theme;
    if (theme && theme.id && theme.role && theme.role !== 'main') {
      url += '&preview_theme_id=' + theme.id;
    }

    return fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status);
        var type = r.headers.get('content-type') || '';
        /* Het fragment komt binnen als text/html; alleen een volledige
           HTML-pagina betekent dat het verkeerde thema antwoordde. */
        return r.text().then(function (body) {
          var trimmed = body.replace(/^﻿/, '').trim();
          if (trimmed.charAt(0) !== '{') {
            throw new Error('geen JSON (' + type + ')');
          }
          return JSON.parse(trimmed);
        });
      })
      .then(function (data) {
        if (!data || data.ok !== true) throw new Error('onverwacht antwoord');
        writeStore('sessionStorage', cacheKey(handle), JSON.stringify({ t: Date.now(), d: data }));
        return data;
      });
  }

  /* ------------------------------------------------------- vergelijkpagina */
  function handlesFromUrl() {
    var match = window.location.search.match(/[?&]p=([^&]+)/);
    if (!match) return null;
    return decodeURIComponent(match[1])
      .split(',')
      .map(function (h) { return h.trim(); })
      .filter(Boolean)
      .slice(0, MAX);
  }

  /* Leeg is een verschil zodra een andere kolom wél iets heeft. Een streepje
     of "n.v.t." telt als leeg, anders zou opmaakverschil als spec-verschil
     tellen. */
  function normValue(v) {
    var s = String(v == null ? '' : v)
      .replace(/ /g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (s === '-' || s === '–' || s === 'n.v.t.' || s === 'nvt' || s === 'k.a.') return '';
    return s;
  }

  function valueFor(row, product) {
    if (!product) return '';
    var direct = product.velden ? product.velden[row.key] : null;
    /* Een markering als "n.v.t." krijgt geen eenheid achter zich: met "n.v.t. cm"
       herkent normValue() hem niet meer en komt hij als waarde in beeld. */
    if (direct) return row.eenheid && normValue(direct) !== '' ? direct + ' ' + row.eenheid : direct;

    var candidates = [row.label].concat(row.aliassen || []);
    for (var i = 0; i < candidates.length; i++) {
      var hit = product._blob[normLabel(candidates[i])];
      if (hit) return hit;
    }
    return '';
  }

  function buildTable(section, products) {
    var rows = JSON.parse(section.dataset.rijen || '[]');
    var table = section.querySelector('[data-dga-cmp-table]');
    if (!table) return;

    var caption = table.querySelector('caption');
    if (caption) caption.textContent = str('tabelCaption').replace('{n}', products.length);

    /* Kop: productkaart per kolom */
    var headRow = table.querySelector('thead tr');
    headRow.textContent = '';
    var corner = document.createElement('th');
    corner.scope = 'col';
    corner.className = 'dga-cmp__corner';
    headRow.appendChild(corner);

    /* Op mobiel vervalt de kenmerkkolom en dus ook de hoekcel; het raster
       heeft dan alleen productkolommen. */
    section.style.setProperty('--dga-cols', products.length);

    products.forEach(function (p) {
      var th = document.createElement('th');
      th.scope = 'col';
      th.className = 'dga-cmp__head';
      th.appendChild(productHeader(section, p));
      headRow.appendChild(th);
    });

    /* Lichaam: één tbody per groep */
    var body = table.querySelectorAll('tbody');
    for (var b = 0; b < body.length; b++) body[b].remove();

    var current = null;
    rows.forEach(function (row) {
      if (row.type === 'groep') {
        current = document.createElement('tbody');
        current.dataset.groep = row.key || row.label;
        var gr = document.createElement('tr');
        gr.className = 'dga-cmp__grouprow';
        var gh = document.createElement('th');
        gh.scope = 'colgroup';
        gh.colSpan = products.length + 1;
        gh.textContent = row.label;
        gr.appendChild(gh);
        current.appendChild(gr);
        table.appendChild(current);
        return;
      }

      if (!current) {
        current = document.createElement('tbody');
        table.appendChild(current);
      }

      var values = products.map(function (p) { return valueFor(row, p); });
      var filled = values.filter(function (v) { return normValue(v) !== ''; });

      /* Rij waar élke kolom leeg is verdwijnt volledig. Bij de huidige
         datavulling is dat functioneel, geen afwerking. */
      if (!filled.length) return;

      var tr = document.createElement('tr');
      tr.dataset.rij = row.key;

      var unique = {};
      filled.forEach(function (v) { unique[normValue(v)] = 1; });
      var same = Object.keys(unique).length <= 1 && filled.length === products.length;
      if (same) tr.dataset.dgaSame = '1';

      var th = document.createElement('th');
      th.scope = 'row';
      th.textContent = row.label;
      tr.appendChild(th);

      values.forEach(function (v) {
        var td = document.createElement('td');
        td.dataset.label = row.label;
        if (normValue(v) === '') {
          var dash = document.createElement('span');
          dash.className = 'dga-cmp__empty';
          dash.setAttribute('aria-label', str('nietOpgegeven'));
          dash.textContent = '–';
          td.appendChild(dash);
        } else {
          td.textContent = v;
        }
        tr.appendChild(td);
      });

      current.appendChild(tr);
    });

    /* Groep is "gelijk" als al zijn rijen dat zijn, zodat de toggle hele
       groepen kan verbergen. */
    table.querySelectorAll('tbody').forEach(function (tb) {
      var dataRows = tb.querySelectorAll('tr[data-rij]');
      if (!dataRows.length) {
        tb.remove();
        return;
      }
      var allSame = true;
      dataRows.forEach(function (r) { if (!r.dataset.dgaSame) allSame = false; });
      if (allSame) tb.dataset.dgaSame = '1';
    });
  }

  function productHeader(section, p) {
    var wrap = document.createElement('div');
    wrap.className = 'dga-cmp__card';

    /* Vaste beeldhoogte, zodat titel, prijs en knop in elke kolom op dezelfde
       lijn beginnen en er geen witruimte onder een klein plaatje ontstaat. */
    var box = document.createElement('div');
    box.className = 'dga-cmp__imgbox';
    if (p.image) {
      var img = document.createElement('img');
      img.src = p.image.replace(/([?&])width=\d+/, '$1width=480');
      img.alt = '';
      img.loading = 'lazy';
      box.appendChild(img);
    }
    wrap.appendChild(box);

    var link = document.createElement('a');
    link.href = p.url;
    link.className = 'dga-cmp__title';
    link.textContent = p.title;
    wrap.appendChild(link);

    var price = document.createElement('p');
    price.className = 'dga-cmp__price';
    price.textContent = p.price_formatted || '';
    wrap.appendChild(price);

    /* B2B: boven € 3.000 is offerte de primaire actie, niet bestellen.
       Zelfde grens als de leasegate in dga-card-product.liquid r.514. */
    var cta = document.createElement('a');
    cta.href = p.url;
    cta.className = 'dga-cmp__cta';
    cta.textContent = section.dataset.ctaBekijk || 'Automaat bekijken';
    wrap.appendChild(cta);

    var del = document.createElement('button');
    del.type = 'button';
    del.className = 'dga-cmp__remove';
    del.setAttribute('aria-label', str('verwijderLabel').replace('{titel}', p.title));
    del.textContent = '×';
    del.addEventListener('click', function () {
      API.remove(p.id);
      window.location.search = '?p=' + API.handles().join(',');
    });
    wrap.appendChild(del);

    return wrap;
  }

  /* Op desktop staat de verschillen-schakelaar in de lege hoekcel, vlak boven
     het eerste kenmerk. Op mobiel bestaat die cel niet, dan staat hij boven de
     tabel. Verplaatsen bij een breedtewissel, anders verdwijnt hij. */
  function plaatsSchakelaar(section) {
    var diff = section.querySelector('[data-dga-cmp-diffwrap]');
    var corner = section.querySelector('.dga-cmp__corner');
    var wrap = section.querySelector('[data-dga-cmp-wrap]');
    var scroll = section.querySelector('.dga-cmp__scroll');
    if (!diff || !wrap || !scroll) return;

    var breed = window.matchMedia('(min-width: 768px)');

    function zet() {
      if (breed.matches && corner) {
        if (diff.parentNode !== corner) corner.appendChild(diff);
      } else if (diff.parentNode !== wrap) {
        wrap.insertBefore(diff, scroll);
      }
    }
    zet();
    if (breed.addEventListener) breed.addEventListener('change', zet);
  }

  /* Meescrollende balk met thumbnail, titel en prijs.
     Bewust een losse, vast gepositioneerde balk in plaats van een sticky thead:
     een sticky element wordt omlaag geduwd zodra zijn eigen positie hoger in
     beeld ligt dan de offset, en dan schuift de kop over de eerste rijen heen.
     Een vaste balk heeft dat probleem niet en houdt de tabel bovendien op zijn
     plek, dus er springt niets als de balk verschijnt. */
  function bouwVolgbalk(section, products) {
    var scroll = section.querySelector('.dga-cmp__scroll');
    var table = section.querySelector('[data-dga-cmp-table]');
    var balk = section.querySelector('[data-dga-cmp-sticky]');
    var rij = section.querySelector('[data-dga-cmp-stickyrow]');
    if (!scroll || !table || !balk || !rij) return;

    var thead = table.querySelector('thead');
    rij.textContent = '';

    var koppen = table.querySelectorAll('thead th');
    for (var i = 0; i < koppen.length; i++) {
      var cel = document.createElement('div');
      cel.className = 'dga-cmp__sbcell';
      if (i > 0) {
        var p = products[i - 1];
        if (p.image) {
          var img = document.createElement('img');
          img.src = p.image;
          img.alt = '';
          cel.appendChild(img);
        }
        var titel = document.createElement('span');
        titel.className = 'dga-cmp__sbtitle';
        titel.textContent = p.title;
        cel.appendChild(titel);

        var prijs = document.createElement('span');
        prijs.className = 'dga-cmp__sbprice';
        prijs.textContent = p.price_formatted || '';
        cel.appendChild(prijs);
      }
      rij.appendChild(cel);
    }

    /* --header-height wordt door header.liquid alleen bij init en bij een
       breakpointwissel gezet, terwijl .section-header tijdens het scrollen
       inklapt (announcement bar en logorij verdwijnen). Die variabele is dan te
       groot en de balk zweeft los onder het menu. Daarom de onderrand van de
       sitekop live meten, met de variabele als terugval. */
    var siteKop = document.querySelector('.section-header');

    function kopHoogte() {
      if (siteKop) {
        var r = siteKop.getBoundingClientRect();
        if (r.height) return Math.max(0, r.bottom);
      }
      var css = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      return parseInt(css, 10) || 100;
    }

    /* Kolombreedtes worden van de echte tabel overgenomen, zodat de balk
       uitgelijnd blijft, ook na een resize of taalwissel. */
    function meet() {
      var cellen = rij.children;
      for (var j = 0; j < koppen.length && j < cellen.length; j++) {
        cellen[j].style.width = koppen[j].offsetWidth + 'px';
      }
    }

    var gepland = false;
    function ververs() {
      gepland = false;
      var top = kopHoogte();
      var kop = thead.getBoundingClientRect();
      var vak = scroll.getBoundingClientRect();
      /* Tonen zodra de echte kop voorbij is, en weer verbergen als de tabel
         zelf uit beeld is. */
      var toon = kop.bottom <= top && vak.bottom > top + 48;
      if (!toon) {
        balk.hidden = true;
        return;
      }
      if (balk.hidden) {
        balk.hidden = false;
        meet();
      }
      balk.style.top = top + 'px';
      balk.style.left = vak.left + 'px';
      balk.style.width = vak.width + 'px';
      rij.style.transform = 'translateX(' + -scroll.scrollLeft + 'px)';
    }

    function plan() {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(ververs);
    }

    window.addEventListener('scroll', plan, { passive: true });
    window.addEventListener('resize', function () { meet(); plan(); });
    /* Het inklappen van de sitekop duurt 0,25s. Zonder deze listener blijft de
       balk op de oude hoogte staan als je stopt met scrollen tijdens de animatie. */
    if (siteKop) siteKop.addEventListener('transitionend', plan);
    scroll.addEventListener('scroll', plan, { passive: true });
    section.querySelectorAll('thead img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', plan, { once: true });
    });
    plan();
  }

  function initPage() {
    var section = document.querySelector('[data-dga-vergelijker]');
    if (!section) return;
    page = section;

    var handles = handlesFromUrl();
    if (!handles || !handles.length) {
      handles = API.handles();
      if (handles.length) {
        history.replaceState(null, '', window.location.pathname + '?p=' + handles.join(','));
      }
    }

    var empty = section.querySelector('[data-dga-cmp-leeg]');
    var wrap = section.querySelector('[data-dga-cmp-wrap]');

    if (!handles.length) {
      if (empty) empty.hidden = false;
      if (wrap) wrap.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (wrap) wrap.hidden = false;

    Promise.allSettled(handles.map(fetchProduct)).then(function (results) {
      var products = [];
      var fouten = [];
      results.forEach(function (r, i) {
        if (r.status !== 'fulfilled' || !r.value || !r.value.ok) {
          fouten.push(handles[i] + (r.reason ? ' (' + r.reason.message + ')' : ''));
          products.push({
            id: handles[i], handle: handles[i], title: handles[i],
            url: '/products/' + handles[i], velden: {}, _blob: {}, blob: '', _error: true
          });
          return;
        }
        var p = r.value;
        p._blob = parseBlob(p.blob);
        vulAfmetingenAan(p);
        products.push(p);
      });

      /* Zonder deze melding ziet een mislukte fetch eruit als ontbrekende
         data, en ga je de verkeerde kant op zoeken. */
      var slot = section.querySelector('[data-dga-cmp-fout]');
      if (slot) {
        if (fouten.length) {
          slot.textContent = (section.dataset.foutMelding || 'Kon deze automaten niet laden:') + ' ' + fouten.join(', ');
          slot.hidden = false;
        } else {
          slot.hidden = true;
        }
      }

      buildTable(section, products);
      plaatsSchakelaar(section);
      bouwVolgbalk(section, products);

      var toggle = section.querySelector('[data-dga-cmp-diff]');
      if (toggle) {
        toggle.addEventListener('change', function () {
          section.toggleAttribute('data-only-diff', toggle.checked);
        });
      }
    });
  }

  /* ------------------------------------------------------------------- init */
  function boot() {
    load();
    initBar();
    syncCheckboxes();
    initPage();
  }

  /* facets.js en Ajaxinate vervangen of vullen grid-HTML aan. Eén observer
     dekt beide; het setTimeout-patroon van het chips-script is een gok. */
  function observeGrid() {
    var targets = document.querySelectorAll('#product-grid, .AjaxinateContainer');
    if (!targets.length || !window.MutationObserver) return;
    var pending = null;
    var observer = new MutationObserver(function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(syncCheckboxes, 50);
    });
    for (var i = 0; i < targets.length; i++) {
      observer.observe(targets[i], { childList: true, subtree: true });
    }
  }

  document.addEventListener(EVENT, function () {
    renderBar();
    syncCheckboxes();
  });

  /* Een ander tabblad schrijft; storage vuurt niet in het schrijvende tabblad,
     daar doet emit() het werk. */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    load();
    renderBar();
    syncCheckboxes();
  });

  window.addEventListener('pageshow', function () {
    load();
    renderBar();
    syncCheckboxes();
  });

  document.addEventListener('shopify:section:load', function () {
    initBar();
    syncCheckboxes();
    observeGrid();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); observeGrid(); });
  } else {
    boot();
    observeGrid();
  }
})();
